import {Container, Row,Col} from "react-bootstrap"

export const About = () => {
    return(
        <section className="about" id="about">
            <Container>
                <Row className="align-items-center pt-5">
                    <Col xs={12} md={6} xl={7}>
                        <h1>Hi my name is Safa HELVACI</h1>
                        <p>I'm a fast learner and an adaptable person. I have a career goal in Full-Stack Development, I have completed
                        my education in applied HTML5, CSS, Boostrap, JavaScript, DataScience with Python, and IOS development
                        with Swift language in institutions such as patika.dev and Kodluyoruz.org.I have completed SAP Business One
                        course on Udemy. Currently, I am doing Front-end and IOS projects and learning react and redux. I want to
                        work in a position where I could use my problem-solving talents, and improve my technical knowledge and
                        skills to do successful projects and meet the goals of the institution I work for.</p>
                    </Col >
                    
                </Row>
            </Container>
        </section>
    )
}